interface IProps {
    readonly description: string;
}

function BrandDescription({description}: IProps) {
    return (
        <div className="mt-5 flex justify-center rounded-2xl bg-white p-5 ">
            <div className="my-2" dangerouslySetInnerHTML={{__html: description}} />
        </div>
    );
}

export default BrandDescription;
